import { SVGProps, Ref, forwardRef } from 'react';

export const BulletFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M4 8c0-2 1-4 4-4s4 2 4 4-1 4-4 4-4-2-4-4" fill="currentColor" />
    </svg>
));
BulletFilledSize16Glyph.displayName = 'BulletFilledSize16Glyph';
